<!-- SVG symbol definitions — hidden, referenced by id below -->
<svg aria-hidden="true" style="display:none">
  <defs>
    <symbol id="icon-user" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/>
      <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </symbol>
    <symbol id="icon-globe" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4"/>
      <ellipse cx="8" cy="8" rx="3" ry="6" stroke="currentColor" stroke-width="1.4"/>
      <path d="M2 8h12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </symbol>
    <symbol id="icon-clock" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4"/>
      <path d="M8 5v3.5l2 1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </symbol>
    <symbol id="icon-x-circle" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4"/>
      <path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </symbol>
    <symbol id="icon-impersonate" viewBox="0 0 16 16" fill="none">
      <circle cx="6.5" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/>
      <path d="M1 14c0-3 2.5-5.5 5.5-5.5S12 11 12 14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <path d="M13 8l2 2-2 2M15 10h-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </symbol>
    <symbol id="icon-map-pin" viewBox="0 0 16 16" fill="none">
      <path d="M8 2a4 4 0 0 1 0 8 4 4 0 0 1 0-8z" stroke="currentColor" stroke-width="1.4"/>
      <path d="M4.5 7.5L2 14l6-2 6 2-2.5-6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="8" cy="6" r="1.5" stroke="currentColor" stroke-width="1.2"/>
    </symbol>
  </defs>
</svg>

<div class="um-wrap">

  <ul class="nav nav-tabs um-tabs" role="tablist">

    <li class="nav-item" role="presentation">
      <a class="nav-link active" id="tab-users-link"
         data-bs-toggle="tab" href="#tab-users"
         role="tab" aria-controls="tab-users" aria-selected="true">
        <svg class="tab-icon"><use href="#icon-user"/></svg>
        Users
      </a>
    </li>

    <li *ngIf="loginService.user.isGlobalAdmin" class="nav-item" role="presentation">
      <a class="nav-link" id="tab-global-link"
         data-bs-toggle="tab" href="#tab-global"
         role="tab" aria-controls="tab-global" aria-selected="false"
         (click)="onGlobalTabClick()">
        <svg class="tab-icon"><use href="#icon-globe"/></svg>
        Global Users
      </a>
    </li>

    <li *ngIf="loginService.user.isDeveloper" class="nav-item" role="presentation">
      <a class="nav-link" id="tab-pending-link"
         data-bs-toggle="tab" href="#tab-pending"
         role="tab" aria-controls="tab-pending" aria-selected="false"
         (click)="onPendingTabClick()">
        <svg class="tab-icon"><use href="#icon-clock"/></svg>
        Pending Users
      </a>
    </li>

    <li *ngIf="loginService.user.isDeveloper" class="nav-item" role="presentation">
      <a class="nav-link" id="tab-rejected-link"
         data-bs-toggle="tab" href="#tab-rejected"
         role="tab" aria-controls="tab-rejected" aria-selected="false">
        <svg class="tab-icon"><use href="#icon-x-circle"/></svg>
        Rejected Users
      </a>
    </li>

  </ul>

  <div class="tab-content um-tab-content">

    <div id="tab-users" class="tab-pane fade show active um-tab-pane"
         role="tabpanel" aria-labelledby="tab-users-link">
      <div class="tab-toolbar">
        <button *ngIf="loginService.user.isGlobalAdmin"
                class="um-btn" [disabled]="!selectedUser" (click)="impersonateUser()">
          <svg class="btn-icon"><use href="#icon-impersonate"/></svg>
          Impersonate User
        </button>
        <button *ngIf="loginService.user.isCompanyAdmin && loginService.user.enableFracX"
                class="um-btn" [disabled]="!selectedUser" (click)="selectFracXRegions()">
          <svg class="btn-icon"><use href="#icon-map-pin"/></svg>
          FracX Regions
        </button>
      </div>
      <wc-grid #usersGrid gridKey="clientUsers" [reloadUserOnSave]="true"
               [showQuickSearch]="true" searchPlaceholder="Search users..."
               (selectedRowChange)="onUserSelected($event)" />

      <div *ngIf="selectedUserId && loginService.user.isGlobalAdmin" class="um-roles-panel">
        <div class="um-roles-header">
          Roles for <strong>{{ selectedUser?.['FirstName'] ?? selectedUser?.['firstName'] }} {{ selectedUser?.['LastName'] ?? selectedUser?.['lastName'] }}</strong>
        </div>
        <app-roles-panel mode="user" [targetId]="selectedUserId" [readonly]="false" />
      </div>
    </div>

    <div *ngIf="loginService.user.isGlobalAdmin"
         id="tab-global" class="tab-pane fade um-tab-pane"
         role="tabpanel" aria-labelledby="tab-global-link">
      <global-users #globalUsersComp class="um-child-fill" />
    </div>

    <div *ngIf="loginService.user.isDeveloper"
         id="tab-pending" class="tab-pane fade um-tab-pane"
         role="tabpanel" aria-labelledby="tab-pending-link">
      <pending-users #pendingUsersComp class="um-child-fill" />
    </div>

    <div *ngIf="loginService.user.isDeveloper"
         id="tab-rejected" class="tab-pane fade um-tab-pane"
         role="tabpanel" aria-labelledby="tab-rejected-link">
      <rejected-users class="um-child-fill" />
    </div>

  </div>

</div>
